var _rect, _rect2, _rect3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBrokenCluster = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 4,
  x: 10,
  y: 2,
  stroke: "#333",
  strokeWidth: 1.5,
  rx: 1
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 4,
  x: 2.268,
  y: 17.768,
  stroke: "#333",
  strokeWidth: 1.5,
  rx: 1,
  transform: "rotate(-30 2.268 17.768)"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 4,
  x: 17.672,
  y: 17,
  stroke: "#333",
  strokeWidth: 1.5,
  rx: 1,
  transform: "rotate(-45 17.672 17)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m9.75 10.75 4.5 4.5m0-4.5-4.5 4.5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  fillRule: "evenodd",
  d: "M5.998 6.25c.3.285.313.76.027 1.06a8.301 8.301 0 0 0-1.544 2.294.75.75 0 1 1-1.367-.619 9.801 9.801 0 0 1 1.824-2.709.75.75 0 0 1 1.06-.026Zm-3.016 6.22a.75.75 0 0 1 .769.73 8.31 8.31 0 0 0 .53 2.716.75.75 0 1 1-1.404.529 9.813 9.813 0 0 1-.626-3.206.75.75 0 0 1 .731-.769ZM19.294 18.328a.75.75 0 0 1 .074 1.059 9.803 9.803 0 0 1-2.522 2.074.75.75 0 1 1-.746-1.3 8.302 8.302 0 0 0 2.136-1.758.75.75 0 0 1 1.058-.075ZM8.916 21.491a.75.75 0 0 1 .92-.529 8.308 8.308 0 0 0 2.753.268.75.75 0 1 1 .105 1.497 9.803 9.803 0 0 1-3.25-.317.75.75 0 0 1-.528-.92ZM13.868 4.163a.75.75 0 0 1 .934-.502c1.05.315 2.04.805 2.927 1.448a.75.75 0 0 1-.88 1.215 8.302 8.302 0 0 0-2.48-1.227.75.75 0 0 1-.501-.934ZM19.57 8.07a.75.75 0 0 1 1.016.306 9.814 9.814 0 0 1 1.045 3.094.75.75 0 0 1-1.481.237 8.309 8.309 0 0 0-.886-2.621.75.75 0 0 1 .306-1.016Z",
  clipRule: "evenodd"
})));
export default SvgBrokenCluster;